export const Wait = async (
  ms: number = 100,
  resolveValue: any = true
): Promise<any> => {
  return new Promise((res, rej) => {
    setTimeout(() => res(resolveValue), ms);
  });
};



// WEBPACK FOOTER //
// ./src/app/_helpers/wait-helper.ts